import { Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';
import { canDeactivateGuard } from './helpers/can-deactivate.guard';
import { PortalLayoutComponent } from './layouts/portal/portal.component';
import { AdminLayoutComponent } from './layouts/admin/admin.component';
import { AuthLayoutComponent } from './layouts/auth/auth.component';

export const routes: Routes = [
    { 
        path: '', 
        redirectTo: '/portal',
        pathMatch: 'full'
    },
    {
        path: 'portal',
        component: PortalLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {path: '', redirectTo: 'facility', pathMatch: 'full'},
            {path: 'dashboard', loadComponent: () => import('./pages/portal/dashboard/dashboard.component').then( mod => mod.DashboardComponent)},
            {path: 'purchase', loadComponent: () => import('./pages/portal/purchase/purchase.component').then( mod => mod.PurchaseComponent)},
            {path: 'alternative-usage', loadComponent: () => import('./pages/portal/alternative-usage/alternative-usage.component').then( mod => mod.AlternativeUsageComponent)},
            {
                path: 'chemical-usage',
                children: [
                    {path: '', loadComponent: () => import('./pages/portal/chemical-usage/chemical-usage.component').then( mod => mod.ChemicalUsageComponent)},
                    {path: 'bulk-entry', loadComponent: () => import('./pages/portal/chemical-usage/bulk-entry/bulk-entry.component').then( mod => mod.BulkEntryComponent)},
                    {path: 'import-export', loadComponent: () => import('./pages/portal/chemical-usage/import-export/import-export.component').then( mod => mod.ImportExportComponent)},
                ]
            },
            {path: 'comment-log', loadComponent: () => import('./pages/portal/comment-log/comment-log.component').then( mod => mod.CommentLogComponent)},
            {
                path: 'root-chemicals',
                children: [
                    {path: '', loadComponent: () => import('./pages/portal/root-chemicals/root-chemicals.component').then( mod => mod.RootChemicalsComponent)},
                    {path: 'import-export', loadComponent: () => import('./pages/portal/root-chemicals/import-export/import-export.component').then( mod => mod.ImportExportComponent)},
                ]
            },
            {path: 'forms', loadComponent: () => import('./pages/portal/forms/forms.component').then( mod => mod.FormsComponent)},
            {path: 'supporting-documentation', loadComponent: () => import('./pages/portal/supporting-documentation/instructions/supporting-documentation.component').then( mod => mod.SupportingDocumentationComponent)},
            {path: 'uploaded-documents', loadComponent: () => import('./pages/portal/supporting-documentation/uploaded-documents/uploaded-documents.component').then( mod => mod.UploadedDocumentsComponent)},
            {
                path: 'facility',
                children: [
                    {path: '', loadComponent: () => import('./pages/portal/facility/dashboard/dashboard.component').then( mod => mod.FacilityDashboardComponent)},
                    {path: 'address-info', loadComponent: () => import('./pages/portal/facility/address-info/address-info.component').then( mod => mod.AddressInfoComponent)},
                    {path: 'contact-info', loadComponent: () => import('./pages/portal/facility/contact-info/contact-info.component').then( mod => mod.ContactInfoComponent)},
                    {path: 'general-info', loadComponent: () => import('./pages/portal/facility/general-info/general-info.component').then( mod => mod.GeneralInfoComponent), canDeactivate: [canDeactivateGuard]},
                    {path: 'offsite', loadComponent: () => import('./pages/portal/facility/offsite/offsite.component').then( mod => mod.OffsiteComponent)},
                    {path: 'potw', loadComponent: () => import('./pages/portal/facility/potw/potw.component').then( mod => mod.PotwComponent)},
                    {path: 'waste-treatment', loadComponent: () => import('./pages/portal/facility/waste-treatment/waste-treatment.component').then( mod => mod.WasteTreatmentComponent)},
                    {path: 'water-body', loadComponent: () => import('./pages/portal/facility/water-body/water-body.component').then( mod => mod.WaterBodyComponent)},

                ]
            },
            {
                path: 'reports',
                children: [
                    {path: '', loadComponent: () => import('./pages/portal/reports/threshold-report/threshold-report.component').then( mod => mod.ThresholdReportComponent)},
                    {path: 'threshold-report', loadComponent: () => import('./pages/portal/reports/threshold-report/threshold-report.component').then( mod => mod.ThresholdReportComponent)},
                    {path: 'root-chemical-report', loadComponent: () => import('./pages/portal/reports/root-chemical-report/root-chemical-report.component').then( mod => mod.RootChemicalReportComponent)},
                ]
            }            
        ]
    },
    {
        path: 'admin',
        component: AdminLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {path: '', loadComponent: () => import('./pages/admin/dashboard/dashboard.component').then( mod => mod.AdminDashboardComponent)},
            {path: 'chemical-categories', loadComponent: () => import('./pages/admin/chemical-categories/chemical-categories.component').then( mod => mod.ChemicalCategoriesComponent)},
            {path: 'chemicals', loadComponent: () => import('./pages/admin/chemicals/chemicals.component').then( mod => mod.ChemicalsComponent)},
            {path: 'companies', loadComponent: () => import('./pages/admin/companies/companies.component').then( mod => mod.CompaniesComponent)},
            {path: 'facilities', loadComponent: () => import('./pages/admin/facilities/facilities.component').then( mod => mod.FacilitiesComponent)},
            {
                path: 'facility',
                children: [
                    {path: 'facility-status', loadComponent: () => import('./pages/admin/facility/facility-status/facility-status.component').then( mod => mod.FacilityStatusComponent)},
                ]
            },
            {path: 'messenger', loadComponent: () => import('./pages/admin/messenger/messenger.component').then( mod => mod.MessengerComponent)},
            {path: 'activity', loadComponent: () => import('./pages/admin/activity/activity.component').then( mod => mod.ActivityComponent)},
            {path: 'users', loadComponent: () => import('./pages/admin/users/users.component').then( mod => mod.UsersComponent)},
            {
                path: 'billing',
                children: [
                    {path: '', loadComponent: () => import('./pages/admin/billing/dashboard/dashboard.component').then( mod => mod.BillingDashboardComponent)},
                    {path: 'billingdetails', loadComponent: () => import('./pages/admin/billing/billingdetails/billingdetails.component').then( mod => mod.BillingDetailsComponent)},
                    {path: 'products', loadComponent: () => import('./pages/admin/billing/products/products.component').then( mod => mod.BillingProductsComponent)},
                    {path: 'subscriptions', loadComponent: () => import('./pages/admin/billing/subscriptions/subscriptions.component').then( mod => mod.BillingSubscriptionsComponent)},
                ]
            }               
        ]
    },
    { 
        path: '', 
        component: AuthLayoutComponent, 
        children: [
            {path: 'login', loadComponent: () => import('./pages/auth/login/login.component').then( mod => mod.LoginComponent)},
            {path: 'forgot-password', loadComponent: () => import('./pages/auth/forgot-password/forgot-password.component').then( mod => mod.ForgotPasswordComponent)},
            {path: 'reset-password', loadComponent: () => import('./pages/auth/reset-password/reset-password.component').then( mod => mod.ResetPasswordComponent)},
            {path: 'password', loadComponent: () => import('./pages/auth/password-confirmation/password-confirmation.component').then( mod => mod.PasswordConfirmationComponent)},
        ]
    },
    {path: 'alternative-usage', loadComponent: () => import('./pages/portal/alternative-usage/alternative-usage.component').then( mod => mod.AlternativeUsageComponent)},

    { path: '**', redirectTo: '/portal'}
];
